import {PropsWithChildren, useContext} from "react";
import {DragDropContext} from "react-beautiful-dnd";
import {useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../api/API";
import {BoardContext} from "./BoardContextProvider";
import {useSyncedRef} from "../../misc/SyncedRef";
import {TaskBoardColumn} from "../../api/Tasks2";

export function DropContextWrapper(props: PropsWithChildren<{
    columns: TaskBoardColumn[]
}>) {

    const updateCardPosition = useAsyncAction(async (input) => {
        await api.tasks2.updateCardPosition(input.props)
        input.onDone();
    }, []);

    const ctx = useContext(BoardContext);
    const refreshEverythingRef = useSyncedRef(ctx.refreshEverything);

    const updateColumn = useAsyncAction(async (input) => {
        await api.tasks2.updateBoardColumn(input);
        refreshEverythingRef.current()
    }, []);

    return (
        <DragDropContext
            onDragEnd={(result) => {
                console.log("drag-end", result);

                if(result.type === "COLUMN") {
                    if(!result.destination) return;

                    const cardId = parseInt(result.draggableId.split(":")[1]);
                    const columnId = parseInt(result.destination.droppableId.split(":")[1]);
                    const srcColumnId = parseInt(result.source.droppableId.split(":")[1]);
                    const newIndex = result.destination.index;

                    ctx.setColumnLoadPending([srcColumnId, columnId])

                    updateCardPosition.callback({
                        props: {
                            id: cardId,
                            column: columnId,
                            index: newIndex,
                        },
                        onDone: () => {
                            ctx.reloadColumns([srcColumnId, columnId]);
                        }
                    })

                    return;
                }

                const id = parseInt(result.draggableId.split(":")[1]);
                const col = props.columns.find(c => c.id === id);
                if(!col) return;
                if(!result.destination) return;

                updateColumn.callback(Object.assign({}, col, {
                    sortOrder: result.destination.index > result.source.index ?
                        result.destination.index+2:
                        result.destination.index+1,
                }));
            }}>

            {updateCardPosition.error ? updateCardPosition.LoadingElement : null}
            {props.children}

        </DragDropContext>
    )
}